module.exports = __webpack_public_path__ + "img/arrow.54bca379.svg";